import {
  WelcomeCard,
  WelcomeCardParameters,
} from "@components/layouts/b2b/home/WelcomeCard";

import { createComponentElement } from "../creators/createComponentElement";
import { useComponentData } from "../hooks/useComponentData";
import { ContentComponent } from "../types";
import { useB2B } from "../B2BContext";

const Component = createComponentElement((props, ref) => {
  const { getParameterValues, content, isLoading, ...other } =
    useComponentData<WelcomeCardParameters>(props, ref);

  const { backgroundColor, backgroundDarkColor, textColor, textDarkColor } =
    getParameterValues([
      "backgroundColor",
      "backgroundDarkColor",
      "textColor",
      "textDarkColor",
    ]);

  const { b2B } = useB2B();

  return (
    <WelcomeCard
      name={b2B?.data?.[0]?.name}
      welcomeText={b2B?.data?.[0]?.welcomeText}
      departmentWelcomeText={b2B?.data?.[0]?.departmentWelcomeText}
      parameterValues={{
        backgroundColor,
        backgroundDarkColor,
        textColor,
        textDarkColor,
      }}
      isLoading={isLoading}
    />
  );
});

export const WelcomeCardComponent: ContentComponent = {
  identifier: "COM:B2B:WELCOME:CARD",
  component: Component,
};
